import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritCustomerDocumentImagesQueryParamsType,
  GetCulpritCustomerDocumentImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerDocumentImages/getCulpritCustomerDocumentImagesQuery.type';

export const getCulpritCustomerDocumentImagesFunction = (
  params: GetCulpritCustomerDocumentImagesQueryParamsType,
): Promise<GetCulpritCustomerDocumentImagesQueryResponseType[]> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/images/customer/document/`,
  );
};
